/*
 * @Description: user actions
 */
import { ActionTree, ActionContext } from 'vuex'
import { RootState } from '@/store'
import { state, UserState } from './state'
import { Mutations } from './mutations'
import { UserActionTypes } from './action-types'
import { getUserInfo } from "@/apis/commonApi";
import { UserMutationTypes } from './mutation-types'
import storage, { StorageType } from '@/utils/storage'
import { objCookie } from "@/utils/common";
import { Options, Vue } from "vue-class-component";
import { applyMigrationFromUserInfo, isMigrationCode } from '@/utils/migration'

type AugmentedActionContext = {
  commit<K extends keyof Mutations>(
    key: K,
    payload: Parameters<Mutations[K]>[1],
  ): ReturnType<Mutations[K]>
} & Omit<ActionContext<UserState, RootState>, 'commit'>

export interface Actions {
  [UserActionTypes.ACTION_GET_USER_INFO](
    { commit }: AugmentedActionContext
  ): void;
}

export const actions: ActionTree<UserState, RootState> & Actions = {
  async [UserActionTypes.ACTION_GET_USER_INFO](
      { commit }: AugmentedActionContext
  ) {
    let that = this;
    return await getUserInfo().then((res:any) => {
      commit(UserMutationTypes.SET_USER_INFO, res)
      storage.rcSetItem(StorageType.local, 'jigou-user-info' , JSON.stringify(res))
      // 学校迁移交割：公告期横幅 / 冻结期跳转拦截页
      applyMigrationFromUserInfo(res && res.migration)
      return res
    }).catch((reserr)=>{
      // 交割冻结/完成：不要当无效 token 清登录态
      if (reserr && isMigrationCode(reserr.code)) {
        return null
      }
      //无效token的处理
      objCookie.deleteCookie("jigou-access-token");
      storage.rcRemoveItem(StorageType.local, 'jigou-user-info');
      location.reload();
      return null;
    });
  },
}
